<template>
  <div>
    <div v-if="!this.localeUser.hasEBICS">
      <span v-html="$t('seller.upload.table.assignment.note')"></span>
		<br>
		<br>
      <span v-html="$t('seller.upload.table.assignment.currency.select')"></span>
      <CurrencySelect class="w_15"
          :value="currency"
          :includeOnly= "['EUR', 'USD']"
          :required="true"
          v-model="currency"
      ></CurrencySelect>
      <div v-if="this.currency =='EUR'">
      <el-tabs class="no-line" activeName="first">
        <el-tab-pane label="Deutsch" name="first"><div style="display: inline-block;" class="text_left light_bg_color"><span v-html="$t('seller.upload.manual.tab.de', { companyName: this.companyName, virtualIBAN: this.localeUser.eurBankAccount.tbIban, bic: this.localeUser.eurBankAccount.bic })"></span></div></el-tab-pane>
        <el-tab-pane label="English" name="second"><div style="display: inline-block;" class="text_left light_bg_color"><span v-html="$t('seller.upload.manual.tab.en', { companyName: this.companyName, virtualIBAN: this.localeUser.eurBankAccount.tbIban, bic: this.localeUser.eurBankAccount.bic })"></span></div></el-tab-pane>
        <el-tab-pane label="Française" name="third"><div style="display: inline-block;" class="text_left light_bg_color"><span v-html="$t('seller.upload.manual.tab.fr', { companyName: this.companyName, virtualIBAN: this.localeUser.eurBankAccount.tbIban, bic: this.localeUser.eurBankAccount.bic })"></span></div></el-tab-pane>
        <el-tab-pane label="Polski" name="fourth"><div style="display: inline-block;" class="text_left light_bg_color"><span v-html="$t('seller.upload.manual.tab.pl', { companyName: this.companyName, virtualIBAN: this.localeUser.eurBankAccount.tbIban, bic: this.localeUser.eurBankAccount.bic })"></span></div></el-tab-pane>
      </el-tabs>
      </div>
      <div v-if="this.currency =='USD'">
        <el-tabs class="no-line" activeName="first">
          <el-tab-pane label="Deutsch" name="first"><div style="display: inline-block;" class="text_left light_bg_color"><span v-html="$t('seller.upload.manual.tab.de', { companyName: this.companyName, virtualIBAN: this.localeUser.usdBankAccount.tbIban, bic: this.localeUser.usdBankAccount.bic })"></span></div></el-tab-pane>
          <el-tab-pane label="English" name="second"><div style="display: inline-block;" class="text_left light_bg_color"><span v-html="$t('seller.upload.manual.tab.en', { companyName: this.companyName, virtualIBAN: this.localeUser.usdBankAccount.tbIban, bic: this.localeUser.usdBankAccount.bic })"></span></div></el-tab-pane>
          <el-tab-pane label="Française" name="third"><div style="display: inline-block;" class="text_left light_bg_color"><span v-html="$t('seller.upload.manual.tab.fr', { companyName: this.companyName, virtualIBAN: this.localeUser.usdBankAccount.tbIban, bic: this.localeUser.usdBankAccount.bic })"></span></div></el-tab-pane>
          <el-tab-pane label="Polski" name="fourth"><div style="display: inline-block;" class="text_left light_bg_color"><span v-html="$t('seller.upload.manual.tab.pl', { companyName: this.companyName, virtualIBAN: this.localeUser.usdBankAccount.tbIban, bic: this.localeUser.usdBankAccount.bic })"></span></div></el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div class="flex">
      <div class="md-layout flex_1 upload-group">
        <div
          v-for="(item,index) in upTypeList"
          v-show="activeId==item.type"
          :key="index"
          class="md-layout-item"
        >
          <md-card>
            <md-card-header class="md-card-header-icon">
              <h3>
                {{ $t("seller.upload.manual.title") }}
              </h3>
            </md-card-header>
            <md-card-content>
              <div class="flex flex_column flex_between">
                <div class="card_content_head">
                  <h4 class="text_center">{{$t('seller.upload.manual.step1.title')}}</h4>
                  <md-field>
                    <label>{{$t('seller.upload.manual.option.select.title')}}*</label>
                    <TbSelect v-model="activeId"
							  :search-allow="false"
							  :options="upTypeList"
							  options-value-field="type"
							  :options-display-getter="(item) => $t(item.title)"
                    />
                  </md-field>
                  <div class="icon_tip">
                    <i class="fa secondary_color" :class="item.iconName"></i>
                    {{$t(item.tooltip)}}
                  </div>
                </div>
                <h4
                  v-if="videoUploadPercent == 0 || activeItem.name != item.name"
                  class="text_center font_bold"
                >{{ $t(item.tip) }}</h4>
                <h4
                  class="accent_color"
                  v-if="activeItem.name == item.name && videoUploadPercent > 0"
                >
                  {{ $t("seller.upload.cardlist.Uploading") }}
                  {{ videoUploadPercent + "%" }}
                  {{ $t("seller.upload.cardlist.Documents") }}
                </h4>
                <div style="margin:1rem" @click="changeItem(item)">
                  <FileUpload
                    v-on:chageFile="chageFile"
                    :filUrl="form.url"
                    v-on:changePercent="changePercent"
                    :disable="isLoading"
                    :iconName="item.iconName"
                    :accept="accept"
                    :postType="item.postType"
                  ></FileUpload>
                </div>
                <p class="paf_tip text_center">
                  {{ $t("seller.upload.manual.files.tip") }}
                </p>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>
      <ExcelUpload class="flex_1" @uploaded="onUploadFinished"></ExcelUpload>
    </div>
  </div>
</template>
<script>
import FileUpload from "@/components/templates/FileUpload.vue";
import enumStatus from "@/common/enum";
import ExcelUpload from "@/components/templates/seller/ExcelUpload.vue";
import CurrencySelect from "@/components/templates/select/CurrencySelect.vue";

export default {
  props:{
    currency: {type: String, default: "EUR"},
  },
  components: {
    FileUpload,
    ExcelUpload,
    CurrencySelect
  },
  data() {
    return {
      form: { url: "" },
      upTypeList: [],
      activeItem: {},
      videoUploadPercent: 0,
      isLoading: false,
      accept: "pdf",
      activeId: 1,
    };
  },
  mounted() {
    this.upTypeList = enumStatus.upTypeList;
  },
  methods: {
    changeItem(item) {
      if (this.isLoading) return;
      this.activeItem = item;
    },
    changePercent(data) {
      this.isLoading = true;
      this.videoUploadPercent = data;
      if (data >= 100) {
        setTimeout(() => {
          this.$store.dispatch("setActionPdfDialog", { show: true});
          this.onUploadFinished();
          this.videoUploadPercent = 0;
          this.isLoading = false;
        }, 500);
      }
    },
    onUploadFinished() {
      this.$emit("uploaded");
    }
  },
  computed: {
    localeUser() {
      return this.$sessionStorage.get("localeUser");
    },
    companyName() {
      return this.localeUser.companyName + " via TNP";
    }
  }
};
</script>
<style lang="scss" scoped>
  @import "./upload.scss";
</style>
